import { useCallback } from 'react';
import { getBulkComputedData } from '../../utils/getBulkComputedData';
import { getComputedData } from '../../utils/getComputedData';
import { useGetShouldEvaluateResult } from './useGetShouldEvaluateResult';

export function useGetNoCodeComputedData() {
  const shouldEvaluateResult = useGetShouldEvaluateResult();

  const getNoCodeComputedData = useCallback(
    <T>(
      data: Record<string, unknown> | string | unknown[],
      context: Record<string, unknown>,
      onError?: (e: unknown) => void,
    ) => {
      return getComputedData<T>(data, context, shouldEvaluateResult, undefined, onError);
    },
    [shouldEvaluateResult],
  );

  const getNoCodeBulkComputedData = useCallback(
    <T extends Record<string, string>>(data: T, context: Record<string, unknown>) => {
      return getBulkComputedData<T>(data, context, shouldEvaluateResult);
    },
    [shouldEvaluateResult],
  );

  return { getNoCodeComputedData, getNoCodeBulkComputedData, shouldEvaluateResult };
}

export type UseGetNoCodeComputeDataType = ReturnType<typeof useGetNoCodeComputedData>;
